module.exports = __webpack_public_path__ + "img/img_guide_2.c57158bc.png";